<template>
  <v-dialog
    scrollable
    persistent
    v-model="visable"
    max-width="480px"
  >
    <v-card>
      <v-card-title class="subheading">
        {{titleMessage}}
      </v-card-title>

      <v-divider></v-divider>

      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <div>{{ message }}</div>
      </v-card-text>

      <v-card-actions v-if="onlyOk">
        <v-spacer/>
        <div class="text-xs-center">
          <v-btn depressed color="primary" @click.native="$emit('ok')">确认</v-btn>
        </div>
      </v-card-actions>

      <v-card-actions v-if="!onlyOk">
        <v-spacer/>
        <v-btn flat color="primary" @click.native="$emit('cancel')">取消</v-btn>
        <v-btn depressed color="primary" @click.native="$emit('ok')">确认</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    model: {
      prop: 'visable',
      event: 'input'
    },

    props: ['visable', 'message', 'titleMessage', 'onlyOk'],

    data() {
      return {
        loading: false
      }
    }
  }
</script>

<style scoped>
  div.card div.card__text {
    display: flex;
    font-size: 14px;
    margin: 4px auto;
    padding: 8px 15px;
    position: relative;
  }

  div.card div.card__text > div {
    -ms-flex-item-align: center;
    align-self: center;
    -webkit-box-flex: 1;
    -ms-flex: 1 1;
    flex: 1 1;
    margin-left: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/global/YesNoMsgBox.vue